import { OpportunityType, RewardClass, RiskLevel } from '../types';

export const TYPE_LABELS: Record<OpportunityType, string> = {
  airdrop: 'Airdrop',
  'learn-earn': 'Learn & Earn',
  quest: 'Quest',
  testnet: 'Testnet',
  campaign: 'Campanha',
  faucet: 'Faucet',
  education: 'Programa educativo',
};

export const REWARD_LABELS: Record<RewardClass, { label: string; className: string }> = {
  confirmada: { label: 'Recompensa confirmada', className: 'bg-green-100 text-green-800' },
  estimada: { label: 'Recompensa estimada', className: 'bg-blue-100 text-blue-800' },
  'somente-pontos': { label: 'Somente pontos', className: 'bg-purple-100 text-purple-800' },
  'nao-divulgada': { label: 'Recompensa não divulgada', className: 'bg-gray-100 text-gray-700' },
  'elegibilidade-futura': { label: 'Elegibilidade futura possível', className: 'bg-amber-100 text-amber-800' },
};

export const RISK_LABELS: Record<RiskLevel, { label: string; className: string }> = {
  baixo: { label: 'Risco baixo', className: 'bg-green-100 text-green-800' },
  moderado: { label: 'Risco moderado', className: 'bg-amber-100 text-amber-800' },
  alto: { label: 'Risco alto', className: 'bg-red-100 text-red-800' },
  'nao-recomendado': { label: 'Não recomendado', className: 'bg-red-600 text-white' },
};

export const DIFFICULTY_LABELS: Record<string, string> = {
  iniciante: 'Iniciante',
  intermediario: 'Intermediário',
  avancado: 'Avançado',
};

/** Critérios públicos da metodologia de classificação de risco. */
export const RISK_METHODOLOGY = [
  'Existência de fonte oficial verificável (site, blog ou rede social oficial do projeto).',
  'Reputação e histórico do projeto e da equipe.',
  'Necessidade de depósito ou envio de fundos (aumenta o risco).',
  'Tipo de assinatura de carteira exigida (login inofensivo vs. aprovações de gasto).',
  'Custo de transação envolvido.',
  'Idade e consistência do domínio oficial.',
  'Presença social ativa e verificada.',
  'Existência de auditoria de contratos conhecida.',
  'Pedidos suspeitos (seed phrase, chaves privadas, pagamentos antecipados) — reprovação automática.',
  'Necessidade de informar dados sensíveis além do padrão KYC.',
];
